import React, { useState } from 'react'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import BasicSlide from './BasicSlide'

function AccordianCard ({
  children,
  eventKey,
  callback,
  cardsOpenedFirst,
  setCardsOpenedFirst,
  cardsOpenedSecond,
  setCardsOpenedSecond,
  max
}) {
  const currentCardOpenedFirst = cardsOpenedFirst.includes(eventKey)
  const currentCardOpenedSecond = cardsOpenedSecond.includes(eventKey)
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    if (!cardsOpenedFirst.includes(eventKey) && eventKey != null) {
      setCardsOpenedFirst(oldArray => [...oldArray, eventKey])
    }
    if (
      cardsOpenedFirst.includes(eventKey) &&
      !cardsOpenedSecond.includes(eventKey) &&
      eventKey != null
    ) {
      setCardsOpenedSecond(oldArray => [...oldArray, eventKey])
      if (eventKey < max && !cardsOpenedFirst.includes(eventKey + 1))
        document.getElementById('acc-header' + (eventKey + 1)).click()
    }
    return callback && callback(eventKey)
  })

  const accordionIcon = currentCardOpenedFirst
    ? currentCardOpenedSecond
      ? '/imgs/green-check.svg'
      : '/imgs/grey-tick.svg'
    : '/imgs/plus.svg'
  const accordionClass = currentCardOpenedFirst ? 'checkable' : ''

  return (
    <Card.Header
      as={Card.Header}
      id={'acc-header' + eventKey.toString()}
      style={{ color: currentCardOpenedSecond ? 'grey' : 'black' }}
      onClick={decoratedOnClick}
    >
      <div className={'accordion-header ' + accordionClass}>
        {children}
        <img className='show-mark' alt='nonsense' src={accordionIcon} />
      </div>
    </Card.Header>
  )
}

function RenderAccordian ({
  inputs,
  cardsOpenedFirst,
  setCardsOpenedFirst,
  cardsOpenedSecond,
  setCardsOpenedSecond,
  rounded = true
}) {
  return (
    <Accordion className='right-accordian' defaultActiveKey={0}>
      {inputs.map((item, idx) => (
        <Card className='acc-header our-rounded mb-2' key={idx}>
          <AccordianCard
            eventKey={idx}
            cardsOpenedFirst={cardsOpenedFirst}
            setCardsOpenedFirst={setCardsOpenedFirst}
            cardsOpenedSecond={cardsOpenedSecond}
            setCardsOpenedSecond={setCardsOpenedSecond}
            max={inputs.length - 1}
          >
            <div className='accordion-header-logo-and-title'>
              {item.image && (
                <img
                  alt='nonsense'
                  src={item.image}
                  onError={event => (event.target.style.display = 'none')}
                  className={`accordion-logo me-3 ${
                    rounded ? 'rounded-circle' : ''
                  }`}
                />
              )}
              <div>
                <div className='acc-title'>{item.title}</div>
                {item.subtitle && (
                  <div className='acc-subtitle'>{item.subtitle}</div>
                )}
              </div>
            </div>
          </AccordianCard>
          <Accordion.Collapse eventKey={idx}>
            <Card.Body>
              <div dangerouslySetInnerHTML={{ __html: item.body }} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  )
}

export default function AccordianSlide ({
  nextTo,
  accordianData,
  rounded,
  ...props
}) {
  const [cardsOpenedFirst, setCardsOpenedFirst] = useState([0])
  const [cardsOpenedSecond, setCardsOpenedSecond] = useState([])
  return (
    <BasicSlide
      nextTo={cardsOpenedSecond.length === accordianData.length ? nextTo : null}
      // The content that will apear on the left-hand side of the screen.
      rightContent={
        <RenderAccordian
          inputs={accordianData}
          cardsOpenedFirst={cardsOpenedFirst}
          setCardsOpenedFirst={setCardsOpenedFirst}
          cardsOpenedSecond={cardsOpenedSecond}
          setCardsOpenedSecond={setCardsOpenedSecond}
          rounded={rounded}
        />
      }
      {...props}
    />
  )
}
